export namespace Boxes {
  export interface IBox {
    box_type_id: number;
    box_type_desc: string;
    isDeleted?: boolean;
  }

  export interface IBoxOrder {
    ts_box_type_id: number;
    ts_box_type_desc: string;
    ts_box_height: number;
    ts_box_length: number;
    ts_box_depth: number;
    ts_box_weight: number;
    ts_documents: string;
    ts_screws: string;
    box_order_id?: number;
    isDeleted?: boolean;
  }

  export interface ISavedBoxByOrder
    extends IBox,
      Omit<IBoxOrder, 'ts_box_type_id' | 'ts_box_type_desc'> {
    order_id: number;
    custom: boolean;
    // documents: boolean;
    // screws: boolean;
  }

  export interface IBoxNoByOrder {
    boxesNumber: number;
    orderId: number;
    index?: number;
  }

  export class Box implements IBox {
    box_type_id: number;
    box_type_desc: string;
    isDeleted?: boolean = false;
    constructor(box: IBox) {
      this.box_type_id = box.box_type_id;
      this.box_type_desc = box.box_type_desc;
      this.isDeleted = box.isDeleted;
    }
  }

  export class BoxOrder implements IBoxOrder {
    box_order_id?: number;
    ts_box_type_id: number;
    ts_box_type_desc: string;
    ts_box_height: number;
    ts_box_length: number;
    ts_box_depth: number;
    ts_box_weight: number;
    ts_documents: string;
    ts_screws: string;

    isDeleted?: boolean;

    /**
     * Validation client-side per scatole custom (add-box e box-details
     * modali). Ritorna true se manca almeno una dimensione.
     *
     * 🚨 FIX v2.11.2 (Q2): legacy aveva `if (!this.box_order_id) return true;`
     * come prima riga. Il `box_order_id` è assegnato dal BE SOLO DOPO
     * il salvataggio del record → per una scatola NUOVA (creata
     * nell'add-box modal) è sempre `undefined` → checkForNull
     * ritornava SEMPRE true → bottone Salva nell'add-box era sempre
     * disabled per le custom. Il check su box_order_id non c'entra
     * con la validazione delle dimensioni. Rimosso. Box-details (edit
     * di scatole esistenti) continua a funzionare: scatola passata in
     * input ha già box_order_id valorizzato e dimensioni iniziali.
     */
    checkForNull(): boolean {
      if (!this.ts_box_height) return true;
      if (!this.ts_box_length) return true;
      if (!this.ts_box_depth) return true;
      if (!this.ts_box_weight) return true;
      return false;
    }

    constructor(box: IBoxOrder) {
      if (!box) return;
      this.box_order_id = box.box_order_id;
      this.ts_box_type_id = box.ts_box_type_id;
      this.ts_box_type_desc = box.ts_box_type_desc;
      this.ts_box_height = box.ts_box_height;
      this.ts_box_length = box.ts_box_length;
      this.ts_box_depth = box.ts_box_depth;
      this.ts_box_weight = box.ts_box_weight;
      this.isDeleted = false;
    }
  }
}
